import React, { useMemo } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import ProductShopModal from './ProductShopModal';

// ProductShop — route wrapper giving the salon's online store a permanent,
// SEO-friendly URL (/book/:slug/shop), mirroring the gift-card shop's
// /gift-cards route. Renders the product shop directly; closing returns to the
// salon page. Supports ?product=ID deep links straight to a product's detail.
const ProductShop = () => {
  const { salonSlug, salonId } = useParams();
  const salonIdOrSlug = salonSlug || salonId;
  const history = useHistory();

  // Read once at mount: ?product= deep link, and the pending-checkout draft
  // saved when a signed-out buyer hit checkout (their basket persists via
  // useCart) — on return from sign-in, reopen straight at checkout.
  const { initialProductId, initialView } = useMemo(() => {
    const productId = new URLSearchParams(window.location.search).get('product');
    let view = null;
    try {
      const draft = JSON.parse(localStorage.getItem('pendingProductCheckout') || 'null');
      if (draft) {
        localStorage.removeItem('pendingProductCheckout');
        if (draft.returnUrl === window.location.pathname && localStorage.getItem('accessToken')) {
          view = 'checkout';
        }
      }
    } catch (e) { /* malformed/blocked storage — open the shop normally */ }
    return { initialProductId: productId, initialView: view };
  }, []);

  const goToSalon = () => {
    history.push(salonSlug ? `/book/${salonSlug}` : `/salon/${salonIdOrSlug}`);
  };

  return (
    <ProductShopModal
      salonIdOrSlug={salonIdOrSlug}
      salonSlug={salonSlug}
      initialProductId={initialProductId}
      initialView={initialView}
      onClose={goToSalon}
    />
  );
};

export default ProductShop;
